import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Settings } from '../../core/settings';
import { Category } from '../../documents';
import { Observable } from 'rxjs';
import { deserialize } from 'santee-dcts';
import { FilterItemsLoader } from '../../documents/filter-items-loader';
import { SponsorRouteData } from '../sponsor-route-data';
import { DocumentFilterItem, DocumentFilterItemReadModel } from '../../documents/document-filter-item';

@Injectable()
export class SponsorDocumentsFilterItemsStorage implements FilterItemsLoader {

    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings,
        private readonly sponsorRouteData: SponsorRouteData
    ) { }

    public loadFilterItemsByCategory(category: Category): Observable<DocumentFilterItem[]> {
        return this.http.get(
                    `${this.settings.apiUrl}/sponsor/study/${this.sponsorRouteData.snapshot.selectedStudy.protocolId}/documents-filter-items/${category.categoryId}`
                ).pipe(
                map((r) => deserialize(r, DocumentFilterItemReadModel).documentFilterItems)
            );
    }
}